import camelCase from "lodash/camelCase";
import sample from "lodash/sample";

const makeTableEntry = (id, entry) => ({
  ...entry,
  id,
  name: { id, message: entry.name, defaultMessage: entry.name },
  description: entry.description
    ? {
        id,
        message: entry.description,
        defaultMessage: entry.description,
      }
    : undefined,
});

export const makeTable = (category, entries) => {
  return entries.map((entry) => {
    if (entry.variants) {
      return [
        ...entry.variants.map((variant) =>
          makeTableEntry(
            `${category}.${camelCase(variant?.name ?? variant)}`,
            variant.name ? variant : { name: variant }
          )
        ),
      ];
    }

    return [
      makeTableEntry(
        `${category}.${camelCase(entry.name)}`,
        entry.name ? entry : { name: entry }
      ),
    ];
  });
};

export const fromTable = (table) => sample(sample(table));
